import { t } from "i18next";
import Swal from "sweetalert2";
import { const_routes } from "../helpers/const_routes";
import { debugLogActions } from "../helpers/debugHelper";
import { fetchToken } from "../helpers/fetch";
import { RolesEnum } from "../types/RolesEnum";
import { types } from "../types/types";
import { startLogout } from "./authActions";
import { startGetMenus, startGetMenus_Step3 } from "./menuActions";
import { startLoadingModuleConfigsByRoleAndProcess_Step4 } from "./moduleConfigActions";
import { selectUserInUserRole } from "./userActions";
import {
  clearActiveSpecialistRoleSession,
  persistActiveSpecialistRole,
  resolveModuleAccessForRole,
  resolveSpecialistRoleForLogin
} from "../helpers/activeSpecialistRoleHelper";
import { isFlowEngineGloballyEnabled } from "../helpers/flowEngineConfigHelper";

export const startGetRolesByUserIdLogin = (user_id) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_USER_ROLE}`,
      `get-roles-by-userid/${user_id}`
    );
    const body = await resp.json();

    debugLogActions('---> startGetRolesByUserIdLogin', { 'body': body });

    if (body.ok) {
      const userRole = getUserRoles(body.userRoles, body.count);
      dispatch(getRolesByUserIdLogin(userRole));

      let menus = {
        listGroupRoles: [],
        listGroupModules: []
      }

      if (userRole.isSuperAdministrator) {
        menus.listGroupRoles = ["loggedIn", "Administrator", "Specialist", "End-user"];
      } else if (userRole.isAdministrator && userRole.isSpecialist && userRole.isEndUser) {
        menus.listGroupRoles = ["loggedIn", "Administrator", "Specialist", "End-user"];
      } else if (userRole.isAdministrator && userRole.isSpecialist) {
        menus.listGroupRoles = ["loggedIn", "Administrator", "Specialist"];
      } else if (userRole.isAdministrator && userRole.isEndUser) {
        menus.listGroupRoles = ["loggedIn", "Administrator", "End-User"];
      } else if (userRole.isSpecialist && userRole.isEndUser) {
        menus.listGroupRoles = ["loggedIn", "Specialist", "End-user"];
      } else if (userRole.isAdministrator) {
        menus.listGroupRoles = ["loggedIn", "Administrator"];
      } else if (userRole.isSpecialist) {
        menus.listGroupRoles = ["loggedIn", "Specialist"];
      } else if (userRole.isEndUser) {
        menus.listGroupRoles = ["loggedIn", "End-User"];
      }

      menus.listGroupModules = ["Technology", "AlternativeTechnology"];

      dispatch(startGetMenus(menus));

      dispatch(startLoadingModuleConfigsByRoleAndProcess_Step4("Administrator", 'TECHNOLOGY'));

    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

export const startGetRolesByUserId_Step2 = (user_id) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_USER_ROLE}`,
      `get-roles-by-userid/${user_id}`
    );
    const body = await resp.json();

     debugLogActions('---> startGetRolesByUserIdLogin', { 'body': body });

    if (body.ok) {
      const userRole = getUserRoles(body.userRoles, body.count);
      
      dispatch(getRolesByUserIdLogin(userRole));

      dispatch(startGetMenus_Step3(userRole, user_id));
      dispatch(syncActiveSpecialistRoleAfterLogin(userRole, user_id));

      dispatch(startLoadingModuleConfigsByRoleAndProcess_Step4("Administrator", 'TECHNOLOGY'));

    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

export const startGetRolesByUserIdSelected = (user) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_USER_ROLE}`,
      `get-roles-by-userid/${user.id}`
    );
    const body = await resp.json();

    debugLogActions('---> startGetRolesByUserIdSelected', { 'body': body });

    if (body.ok) {

      const userRole = getUserRoles(body.userRoles, body.count);

      dispatch(selectUserInUserRole(user));
      dispatch(getRolesByUserIdSelected(userRole));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

export const getRolesByUserIdLogin = (userRole) => ({
  type: types.USERROLE_LOGIN,
  payload: userRole,
});

const getRolesByUserIdSelected = (userRole) => ({
  type: types.USERROLE_SELECTED,
  payload: userRole,
});

export const cleanUserRoleSelected = () => ({
  type: types.USERROLE_SELECTED_CLEAN,
});

export const getUserRoles = (userRoles, count) => {
  let userRole = {
    roles: userRoles,
    haveRole: true,
    haveOnlyOneRole: false,
    haveMultipleRoles: false,
    roleUnique: {},

    isAdministrator: false,
    roleAdministrator: {},
    isSpecialist: false,
    roleSpecialist: {},
    isRoleSpecialistSelected: false,
    roleSpecialistSelected: {},

    isSpecialistFeeder: false,
    roleSpecialistFeeder: {},
    isSpecialistPreManager: false,
    roleSpecialistPreManager: {},
    isSpecialistManager: false,
    roleSpecialistManager: {},
    isSpecialistValidator: false,
    roleSpecialistValidator: {},
    isSpecialistEditor: false,
    roleSpecialistEditor: {},
    isSpecialistCoordinator: false,
    roleSpecialistCoordinator: {},
    isSpecialistLiaison: false,
    roleSpecialistLiaison: {},
    isEndUser: false,
    roleEndUser: {},
    isEndUserInstitutional: false,
    roleEndUserInstitutional: {},
    isClient: false,
    roleReporter: {},
    isReporter: false,
    roleClient: {},
    bagRoleIds: [],
  };

  if (count === 0) {
    
    userRole.haveRole = false;
  } else if (count === 1) {
    
    userRole.haveOnlyOneRole = true;
    userRole.roleUnique = userRoles[0].CatalogRole_To_UserRole;
    userRole.bagRoleIds.push(userRoles[0].CatalogRole_To_UserRole.id);

    if (userRoles[0].CatalogRole_To_UserRole.name === RolesEnum.ADMINISTRATOR) {
      
      userRole.isAdministrator = true;
      userRole.roleAdministrator = userRoles[0].CatalogRole_To_UserRole;
      
    } else if (
      userRoles[0].CatalogRole_To_UserRole.name === RolesEnum.SPECIALIST_FEEDER
      || userRoles[0].CatalogRole_To_UserRole.name === 'Specialist-Leader'
    ) {
      
      userRole.isSpecialist = true;
      userRole.roleSpecialist = userRoles[0].CatalogRole_To_UserRole;
      
      userRole.isRoleSpecialistSelected = true;
      userRole.roleSpecialistSelected = userRoles[0].CatalogRole_To_UserRole;

        userRole.isSpecialistFeeder = true;
        userRole.roleSpecialistFeeder = userRoles[0].CatalogRole_To_UserRole;

    } else if (userRoles[0].CatalogRole_To_UserRole.name === RolesEnum.SPECIALIST_MANAGER) {
      userRole.isSpecialist = true;
      userRole.roleSpecialist = userRoles[0].CatalogRole_To_UserRole;
      userRole.isSpecialistManager = true;
      userRole.roleSpecialistManager = userRoles[0].CatalogRole_To_UserRole;
      userRole.isRoleSpecialistSelected = true;
      userRole.roleSpecialistSelected = userRoles[0].CatalogRole_To_UserRole;
    } else if (
      userRoles[0].CatalogRole_To_UserRole.name === RolesEnum.SPECIALIST_VALIDATOR
      || userRoles[0].CatalogRole_To_UserRole.name === RolesEnum.SPECIALIST_VERIFICATOR
    ) {
      userRole.isSpecialist = true;
      userRole.roleSpecialist = userRoles[0].CatalogRole_To_UserRole;
      userRole.isSpecialistValidator = true;
      userRole.roleSpecialistValidator = userRoles[0].CatalogRole_To_UserRole;
      userRole.isRoleSpecialistSelected = true;
      userRole.roleSpecialistSelected = userRoles[0].CatalogRole_To_UserRole;
    } else if (userRoles[0].CatalogRole_To_UserRole.name === RolesEnum.SPECIALIST_EDITOR) {
      userRole.isSpecialist = true;
      userRole.roleSpecialist = userRoles[0].CatalogRole_To_UserRole;
      userRole.isSpecialistEditor = true;
      userRole.roleSpecialistEditor = userRoles[0].CatalogRole_To_UserRole;
      userRole.isRoleSpecialistSelected = true;
      userRole.roleSpecialistSelected = userRoles[0].CatalogRole_To_UserRole;
    } else if (userRoles[0].CatalogRole_To_UserRole.name === RolesEnum.SPECIALIST_COORDINATOR) {
      userRole.isSpecialist = true;
      userRole.roleSpecialist = userRoles[0].CatalogRole_To_UserRole;
      userRole.isSpecialistCoordinator = true;
      userRole.roleSpecialistCoordinator = userRoles[0].CatalogRole_To_UserRole;
      userRole.isRoleSpecialistSelected = true;
      userRole.roleSpecialistSelected = userRoles[0].CatalogRole_To_UserRole;
    } else if (userRoles[0].CatalogRole_To_UserRole.name === RolesEnum.SPECIALIST_PRE_MANAGER) {
      userRole.isSpecialist = true;
      userRole.roleSpecialist = userRoles[0].CatalogRole_To_UserRole;
      userRole.isSpecialistPreManager = true;
      userRole.roleSpecialistPreManager = userRoles[0].CatalogRole_To_UserRole;
      userRole.isRoleSpecialistSelected = true;
      userRole.roleSpecialistSelected = userRoles[0].CatalogRole_To_UserRole;
    } else if (userRoles[0].CatalogRole_To_UserRole.name === RolesEnum.SPECIALIST_LIAISON) {
      userRole.isSpecialist = true;
      userRole.roleSpecialist = userRoles[0].CatalogRole_To_UserRole;
      userRole.isSpecialistLiaison = true;
      userRole.roleSpecialistLiaison = userRoles[0].CatalogRole_To_UserRole;
      userRole.isRoleSpecialistSelected = true;
      userRole.roleSpecialistSelected = userRoles[0].CatalogRole_To_UserRole;

    } else if (userRoles[0].CatalogRole_To_UserRole.name === RolesEnum.END_USER) {
      userRole.isEndUser = true;
      userRole.roleEndUser = userRoles[0].CatalogRole_To_UserRole;
      
    } else if (userRoles[0].CatalogRole_To_UserRole.name === RolesEnum.END_USER_INSTITUTIONAL) {
      userRole.isEndUserInstitutional = true;
      userRole.roleEndUserInstitutional = userRoles[0].CatalogRole_To_UserRole;
      
    } else if (userRoles[0].CatalogRole_To_UserRole.name === RolesEnum.CLIENT) {
      userRole.isClient = true;
      userRole.roleClient = userRoles[0].CatalogRole_To_UserRole;
      
    } else if (userRoles[0].CatalogRole_To_UserRole.name === RolesEnum.REPORTER) {
      userRole.isReporter = true;
      userRole.roleReporter = userRoles[0].CatalogRole_To_UserRole;
      
    }
  } else if (count > 1) {
    userRole.haveMultipleRoles = true;

    let counterMultipleSpecialistRoles = 0;
    userRoles.forEach((role) => {

      if (role.CatalogRole_To_UserRole.name === RolesEnum.ADMINISTRATOR) {
        userRole.isAdministrator = true;
        userRole.roleAdministrator = role.CatalogRole_To_UserRole;
        userRole.bagRoleIds.push(role.CatalogRole_To_UserRole.id);
      } else if (
        role.CatalogRole_To_UserRole.name === RolesEnum.SPECIALIST_FEEDER
        || role.CatalogRole_To_UserRole.name === 'Specialist-Leader'
      ) {
        userRole.isSpecialist = true;
        userRole.roleSpecialist = role.CatalogRole_To_UserRole;

          userRole.isSpecialistFeeder = true;
          userRole.roleSpecialistFeeder = role.CatalogRole_To_UserRole;
          counterMultipleSpecialistRoles = counterMultipleSpecialistRoles + 1;
          userRole.bagRoleIds.push(role.CatalogRole_To_UserRole.id);

      } else if (role.CatalogRole_To_UserRole.name === RolesEnum.SPECIALIST_MANAGER) {
        userRole.isSpecialist = true;
        userRole.roleSpecialist = role.CatalogRole_To_UserRole;
        userRole.isSpecialistManager = true;
        userRole.roleSpecialistManager = role.CatalogRole_To_UserRole;
        counterMultipleSpecialistRoles = counterMultipleSpecialistRoles + 1;
        userRole.bagRoleIds.push(role.CatalogRole_To_UserRole.id);
      } else if (
        role.CatalogRole_To_UserRole.name === RolesEnum.SPECIALIST_VALIDATOR
        || role.CatalogRole_To_UserRole.name === RolesEnum.SPECIALIST_VERIFICATOR
      ) {
        userRole.isSpecialist = true;
        userRole.roleSpecialist = role.CatalogRole_To_UserRole;
        userRole.isSpecialistValidator = true;
        userRole.roleSpecialistValidator = role.CatalogRole_To_UserRole;
        counterMultipleSpecialistRoles = counterMultipleSpecialistRoles + 1;
        userRole.bagRoleIds.push(role.CatalogRole_To_UserRole.id);
      } else if (role.CatalogRole_To_UserRole.name === RolesEnum.SPECIALIST_EDITOR) {
        userRole.isSpecialist = true;
        userRole.roleSpecialist = role.CatalogRole_To_UserRole;
        userRole.isSpecialistEditor = true;
        userRole.roleSpecialistEditor = role.CatalogRole_To_UserRole;
        counterMultipleSpecialistRoles = counterMultipleSpecialistRoles + 1;
        userRole.bagRoleIds.push(role.CatalogRole_To_UserRole.id);
      } else if (role.CatalogRole_To_UserRole.name === RolesEnum.SPECIALIST_COORDINATOR) {
        userRole.isSpecialist = true;
        userRole.roleSpecialist = role.CatalogRole_To_UserRole;
        userRole.isSpecialistCoordinator = true;
        userRole.roleSpecialistCoordinator = role.CatalogRole_To_UserRole;
        counterMultipleSpecialistRoles = counterMultipleSpecialistRoles + 1;
        userRole.bagRoleIds.push(role.CatalogRole_To_UserRole.id);
      } else if (role.CatalogRole_To_UserRole.name === RolesEnum.SPECIALIST_PRE_MANAGER) {
        userRole.isSpecialist = true;
        userRole.roleSpecialist = role.CatalogRole_To_UserRole;
        userRole.isSpecialistPreManager = true;
        userRole.roleSpecialistPreManager = role.CatalogRole_To_UserRole;
        counterMultipleSpecialistRoles = counterMultipleSpecialistRoles + 1;
        userRole.bagRoleIds.push(role.CatalogRole_To_UserRole.id);
      } else if (role.CatalogRole_To_UserRole.name === RolesEnum.SPECIALIST_LIAISON) {
        userRole.isSpecialist = true;
        userRole.roleSpecialist = role.CatalogRole_To_UserRole;
        userRole.isSpecialistLiaison = true;
        userRole.roleSpecialistLiaison = role.CatalogRole_To_UserRole;
        counterMultipleSpecialistRoles = counterMultipleSpecialistRoles + 1;
        userRole.bagRoleIds.push(role.CatalogRole_To_UserRole.id);
      } else if (role.CatalogRole_To_UserRole.name === RolesEnum.END_USER) {
        userRole.isEndUser = true;
        userRole.roleEndUser = role.CatalogRole_To_UserRole;
        userRole.bagRoleIds.push(role.CatalogRole_To_UserRole.id);
      } else if (role.CatalogRole_To_UserRole.name === RolesEnum.END_USER_INSTITUTIONAL) {
        userRole.isEndUserInstitutional = true;
        userRole.roleEndUserInstitutional = role.CatalogRole_To_UserRole;
        userRole.bagRoleIds.push(role.CatalogRole_To_UserRole.id);
      } else if (role.CatalogRole_To_UserRole.name === RolesEnum.CLIENT) {
        userRole.isClient = true;
        userRole.roleClient = role.CatalogRole_To_UserRole;
        userRole.bagRoleIds.push(role.CatalogRole_To_UserRole.id);
      } else if (role.CatalogRole_To_UserRole.name === RolesEnum.REPORTER) {
        userRole.isReporter = true;
        userRole.roleReporter = role.CatalogRole_To_UserRole;
        userRole.bagRoleIds.push(role.CatalogRole_To_UserRole.id);
      }
    });

    if (counterMultipleSpecialistRoles === 1) {
      userRole.isRoleSpecialistSelected = true;
      userRole.roleSpecialistSelected = userRole.roleSpecialist;
    }

  }

  return userRole;
};

export const startRegisterUserRolesList = (userRoles, idUserRole) => {
  return async (dispatch) => {
    const userRolesObjectSend = {
      userRolesObject: { userRoles, idUserRole },
    };

    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_USER_ROLE}`,
      "add-list",
      userRolesObjectSend,
      "POST"
    );
    const body = await resp.json();

    if (body.ok) {
      dispatch(registerUserRolesList(userRoles));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const registerUserRolesList = (userRole) => ({
  type: types.USERROLE_START_REGISTER_LIST,
  payload: userRole,
});

export const startRegisterUserRoleClient = (user_id, catalogrole_id) => {
  return async (dispatch) => {
    const userRoleClient = {
      deleted: false,
      user_id: user_id,
      catalogrole_id: catalogrole_id,
    };

    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_USER_ROLE}`,
      "add",
      userRoleClient,
      "POST"
    );
    const body = await resp.json();

    if (body.ok) {
      dispatch(registerUserRoleClient(userRoleClient));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const registerUserRoleClient = (userRoleSave) => ({
  type: types.USERROLE_START_REGISTER_CLIENT,
  payload: userRoleSave,
});

export const selectSpecialistRoleToWork = (userRole) => (dispatch, getState) => {
  const userId = getState().auth?.user?.user_id || getState().auth?.user?.id;
  const moduleAccessByRole = getState().userRole?.roleLogin?.moduleAccessByRole || {};
  const moduleAccess = resolveModuleAccessForRole(moduleAccessByRole, userRole);

  if (userRole?.id) {
    persistActiveSpecialistRole(userRole, userId);
  }

  dispatch({
    type: types.USERROLE_SELECTED_SPECIALIST,
    payload: { ...userRole, moduleAccess }
  });
};

export const syncActiveSpecialistRoleAfterLogin = (userRole, userId) => (dispatch, getState) => {
  const configuration = getState().configuration;
  const flowEngineEnabled = isFlowEngineGloballyEnabled(configuration);
  const resolvedRole = resolveSpecialistRoleForLogin({
    roleLogin: userRole,
    flowEngineEnabled,
    userId
  });

  if (resolvedRole) {
    dispatch(selectSpecialistRoleToWork(resolvedRole));
  }
};

export const clearActiveSpecialistRoleOnLogout = () => {
  clearActiveSpecialistRoleSession();
};